export default {
    dashboard: 'Dashboard',
    digitalOrders: 'Digital Orders',
    delivery: 'Delivery Orders',
    dineIn: 'Dine in Orders',
    testPrint: 'testPrint',
    report: 'Reports',
    general: 'General',
    createTab: 'Create Tab',
    home: 'Home',
    menuEditor: 'Menu Editor',
    profileMenuEditor: 'Profile menu editor',
    orderHistory: 'Order History',
    settings: 'Settings',
    support: 'Support',
    todayOrders: 'Today Orders',
    pickup: 'Pickup Orders',
    specialEventOrders: 'Special Event Orders',
    logOut: 'Log out',
    businessProfile: 'Business Profile',
    loyalty: 'Loyalty',
    menuBoard:'Menu Board',
    visuals:'Visuals',
    menuDisplay:"Menu Display",
    itemAvailabilityControl: 'Item Availability',
    modifiers: 'Modifiers',
    myMenu: 'My Menu',
    users: 'Users',
    serverShift: 'Server Shift',
    endOfDay: 'End of Day',
    SalesInsights: 'Sales Insights',
    Overview: 'Overview',
    ticket: 'Today Tickets',
    tipSummary: 'Tip Summary',
    TutorialVideoclips: 'Tutorial Videoclips',
    contactUs: 'Contact Us',
    downloads: 'Downloads',
    menuDisplays: 'Menu Displays'
}
